(() => {
    const $siteHeader = document.querySelector('.site-header__inner');
    
    const setBodyWidthVar = () => {
        document.documentElement.style.setProperty('--body-width', `${document.body.offsetWidth}px`);
    };
    
    const setBodyHeightVar = () => {
        document.documentElement.style.setProperty('--body-height', `${document.body.offsetHeight}px`);
    };

    const setSiteHeaderVar = () => {
        document.documentElement.style.setProperty('--site-header-height', `${($siteHeader?.offsetHeight ?? 0)}px`);
    };

    const setAdminBarHeightVar = () => {
        const $wpadminbar = document.querySelector('#wpadminbar');

        const topPos = $wpadminbar?.offsetHeight && window.innerHeight ? $wpadminbar?.offsetHeight : 0;

        document.documentElement.style.setProperty('--admin-bar-height', `${topPos}px`);
    };

    const setContainerPaddingOffsetVar = () => {
        let containerPaddingOffset = 16;

        if (window.innerWidth >= 375) {
            containerPaddingOffset = 20;
        }
        
        if (window.innerWidth >= 1024) {
            containerPaddingOffset = 40;
        }
        
        if (window.innerWidth >= 1440) {
            containerPaddingOffset = 80;
        }
        
        if (window.innerWidth >= 1440) {
            containerPaddingOffset = ((document.body.offsetWidth - 1440) / 2) + 40;
        }

        document.documentElement.style.setProperty('--container-padding-offset', `${containerPaddingOffset}px`);
    };

    const setContainerInnerWidthVar = () => {
        let containerPaddingOffset = 16;

        if (window.innerWidth >= 375) {
            containerPaddingOffset = 20;
        }
        
        if (window.innerWidth >= 1024) {
            containerPaddingOffset = 40;
        }
        
        if (window.innerWidth >= 1440) {
            containerPaddingOffset = 80;
        }
        
        if (window.innerWidth >= 1440) {
            containerPaddingOffset = ((document.body.offsetWidth - 1440) / 2) + 100;
        }

        document.documentElement.style.setProperty('--container-inner-width', `${document.body.offsetWidth - containerPaddingOffset * 2}px`);
    };

    const setContainerOffsetVar = () => {
        let containerOffset = 0;

        if (window.innerWidth >= 1440) {
            containerOffset = (window.innerWidth - 1440) / 2;
        }

        document.documentElement.style.setProperty('--container-offset', `${containerOffset}px`);
    };

    window.addEventListener('load', () => {
        setBodyWidthVar();
        setBodyHeightVar();
        setSiteHeaderVar();
        setAdminBarHeightVar();
        setContainerPaddingOffsetVar();
        setContainerInnerWidthVar();
        setContainerOffsetVar();
    });

    window.addEventListener('resize', () => {
        setBodyWidthVar();
        setBodyHeightVar();
        setSiteHeaderVar();
        setAdminBarHeightVar();
        setContainerPaddingOffsetVar();
        setContainerInnerWidthVar();
        setContainerOffsetVar();

        window.requestAnimationFrame(() => {
            setBodyWidthVar();
            setBodyHeightVar();
            setSiteHeaderVar();
            setAdminBarHeightVar();
            setContainerPaddingOffsetVar();
            setContainerInnerWidthVar();
            setContainerOffsetVar();
        })
    });

    setBodyWidthVar();
    setBodyHeightVar();
    setSiteHeaderVar();
    setAdminBarHeightVar();
    setContainerPaddingOffsetVar();
    setContainerInnerWidthVar();
    setContainerOffsetVar();
})();
